import React, { Component } from "react";
import { formatToFriendlyNumber } from "../../../../util";
import ProfilePicture from "../../../../components/ProfilePicture";
import FollowToggleButton from "../../../../components/FollowToggleButton";
import LinkButton from "../../../../components/LinkButton";
import "./index.css";
import { Link } from "redux-little-router";

class ProfileHead extends Component {
  render() {
    const { user, baseUrl, isOwnProfile } = this.props;
    const postsCount = user.totalPostsCount || 0;
    const likesCount = user.totalLikesCount || 0;
    const viewsCount = user.totalViewsCount || 0;
    const collectionsCount = user.totalCollectionsCount || 0;

    // const followersCount = user.totalFollowers || 0;
    // const followingCount = user.totalFollowing || 0;
    return (
      <div className="profile-head">
        <header className="-user-header">
          <img src={require(`./img/cover.jpg`)} alt="" className="-cover-img" />
          <div className="-cover-gradient" />
          <ProfilePicture userId={user._id} size="m" fallbackUrl={user.picture} className="-user-img" alt={user.name} />
          <div className="-user-data-wrapper">
            <div className="-user-data">
              <h2 className="-user-name">{user.name}</h2>
              <div className="-user-headline">{user.headline}</div>
              <div className="-user-speciality">
                {user.speciality && user.speciality !== "Other" && user.speciality}
              </div>
              <div className="-user-bio">{user.shortBio}</div>
              {/*<div className="-user-country">
                {user.country && (
                  <div>
                    <Icon fitted name="marker" />
                    <span>{" " + user.country}</span>
                  </div>
                )}
              </div>*/}
              <FollowToggleButton userId={user._id} isFollowed={user.isFollowed} />
              {isOwnProfile && <LinkButton value="Edit Profile" href="/editprofile" className="-centered" />}
            </div>
            <div className="-user-numbers">
              {postsCount > 0 && (
                <span className="-user-number">
                  <Link href={`${baseUrl}`}>
                    <div className="-text">Cases</div>
                    <p className="-number">{formatToFriendlyNumber(postsCount)}</p>
                  </Link>
                </span>
              )}
              {collectionsCount > 0 && (
                <Link href={`${baseUrl}/collections`}>
                  <span className="-user-number">
                    <div className="-text">Collections</div>
                    <p className="-number">{formatToFriendlyNumber(collectionsCount)}</p>
                  </span>
                </Link>
              )}
              {/*followingCount > 0 && (
                <Link href={`${baseUrl}/following`}>
                  <span className="-user-number">
                    <div className="-text">Following</div>
                    <p className="-number">{formatToFriendlyNumber(followingCount)}</p>
                  </span>
                </Link>
              )}
              {followersCount > 0 && (
                <Link href={`${baseUrl}/followers`}>
                  <span className="-user-number">
                    <div className="-text">Followers</div>
                    <p className="-number">{formatToFriendlyNumber(followersCount)}</p>
                  </span>
                </Link>
              )}*/}
              {likesCount > 0 && (
                <span className="-user-number">
                  <div className="-text">Likes</div>
                  <p className="-number">{formatToFriendlyNumber(likesCount)}</p>
                </span>
              )}
              {viewsCount > 0 && (
                <span className="-user-number">
                  <div className="-text">Case views</div>
                  <p className="-number">{formatToFriendlyNumber(viewsCount)}</p>
                </span>
              )}
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default ProfileHead;



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/ProfileHead/index.js